'use strict';

var getNonce = function () {
    if (typeof __webpack_nonce__ !== 'undefined') {
        return __webpack_nonce__;
    }
    return undefined;
};

exports.getNonce = getNonce;
//# sourceMappingURL=index.cjs.map
